import { Box, Button, Divider, Stack } from '@mui/material';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import TranscriptionTab from './transcriptTab';

import InternalCommentsTab from '../internalComments';
import buttonStyle from '../requestInformationTab/styles/buttonStyle';

enum InvestigatorNotesTabs {
  NOTES = 'NOTES',
  TRANSCRIPTS = 'TRANSCRIPTS',
}

function InvestigatorNotesTab() {
  const tabsRef = useRef<HTMLDivElement>(null);
  const [openTab, setOpenTab] = useState<InvestigatorNotesTabs>(
    InvestigatorNotesTabs.NOTES,
  );

  return (
    <Box sx={{ paddingX: '16px', paddingBottom: '16px' }}>
      <Stack
        direction={{
          md: 'row',
          xs: 'column',
        }}
      >
        {Object.values(InvestigatorNotesTabs).map((investigatorNotesTab) => {
          return (
            <Button
              key={`btn-${investigatorNotesTab}`}
              sx={{
                ...buttonStyle,
                color: openTab === investigatorNotesTab ? '#00CECF' : 'gray',
                background: 'transparent',
                borderBottom:
                  openTab === investigatorNotesTab
                    ? '2px solid #00CECF'
                    : 'none',
              }}
              onClick={() => {
                setOpenTab(investigatorNotesTab);
                setTimeout(() => {
                  tabsRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
              }}
            >
              {investigatorNotesTab === InvestigatorNotesTabs.NOTES && (
                <FormattedMessage defaultMessage='Notes' />
              )}
              {investigatorNotesTab === InvestigatorNotesTabs.TRANSCRIPTS && (
                <FormattedMessage defaultMessage='Transcription Calls' />
              )}
            </Button>
          );
        })}
      </Stack>
      <Divider />
      <Box
        sx={{
          height: 'auto',
          marginBottom: '10px',
          scrollbarWidth: 'thin',
          '::-webkit-scrollbar': {
            width: '10px',
          },
          '::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '::-webkit-scrollbar-thumb': {
            bgcolor: 'rgba(155, 155, 155, 0.5)',
            borderRadius: '20px',
            border: 'transparent',
          },
        }}
        ref={tabsRef}
      >
        {openTab === InvestigatorNotesTabs.NOTES && <InternalCommentsTab />}
        {openTab === InvestigatorNotesTabs.TRANSCRIPTS && <TranscriptionTab />}
      </Box>
    </Box>
  );
}

export default InvestigatorNotesTab;
